<template>
  <cube-popup
    v-show="visible"
    ref="s_popub_toast"
    type="my-popup"
    :mask="mask"
  >
    <div
      id="selef_toast"
      class="popup_content"
    >
      <div class="popup_content_main">
        <i :class="['iconfont', typeClass]" />
        <p
          class="text"
          v-text="text"
        />
      </div>
    </div>
  </cube-popup>
</template>

<script type="text/ecmascript-6">
export default {
  data () {
    return {
      visible: false,
      mask: false,
      text: '',
      type: 'success'
    }
  },
  computed: {
    typeClass () {
      switch (this.type) {
        case 'success':
          return 'iconicon-test'
        case 'error':
          return 'iconicon-test1'
        default:
          return 'iconicon-test'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.popup_content {
  width: 161px;
  min-height: 121px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  color: #fff;
  display: flex;
  text-align: center;
  overflow: hidden;
  // animation: all .3s;
  .popup_content_main {
    margin: auto;
    .iconfont {
      font-size: 40px;
      padding-top: 30px;
    }
    .text {
      margin: 13px;
      font-size: 14px;
      line-height: 1.5;
    }
  }
}
</style>
